/**
 * Person puzzles — well-known public figures, era-appropriate for the 70-95+
 * audience. Mix of historical statesmen, classic Hollywood, mid-century
 * authors and musicians, sports legends. Pulled from common-knowledge proper
 * nouns; no copying of biographical prose.
 */
export const PEOPLE = [
  'ABRAHAM LINCOLN',
  'GEORGE WASHINGTON',
  'THOMAS JEFFERSON',
  'BENJAMIN FRANKLIN',
  'THEODORE ROOSEVELT',
  'WINSTON CHURCHILL',
  'ELEANOR ROOSEVELT',
  'AUDREY HEPBURN',
  'CARY GRANT',
  'GRACE KELLY',
  'JAMES STEWART',
  'JOHN WAYNE',
  'KATHARINE HEPBURN',
  'MARLON BRANDO',
  'GREGORY PECK',
  'INGRID BERGMAN',
  'FRED ASTAIRE',
  'GINGER ROGERS',
  'BING CROSBY',
  'BOB HOPE',
  'LUCILLE BALL',
  'WALT DISNEY',
  'ELVIS PRESLEY',
  'FRANK SINATRA',
  'DEAN MARTIN',
  'SAMMY DAVIS JUNIOR',
  'JUDY GARLAND',
  'BARBRA STREISAND',
  'ARETHA FRANKLIN',
  'LOUIS ARMSTRONG',
  'ELLA FITZGERALD',
  'BILLIE HOLIDAY',
  'NAT KING COLE',
  'TONY BENNETT',
  'JOHNNY CASH',
  'WILLIE NELSON',
  'DOLLY PARTON',
  'PATSY CLINE',
  'JIMMY STEWART',
  'CLARK GABLE',
  'ROBERT FROST',
  'ERNEST HEMINGWAY',
  'JOHN STEINBECK',
  'MARK TWAIN',
  'EMILY DICKINSON',
  'WALT WHITMAN',
  'JANE AUSTEN',
  'CHARLES DICKENS',
  'AGATHA CHRISTIE',
  'PEARL BUCK',
  'LOUISA MAY ALCOTT',
  'BABE RUTH',
  'LOU GEHRIG',
  'JOE DIMAGGIO',
  'MICKEY MANTLE',
  'JACKIE ROBINSON',
  'HANK AARON',
  'ROBERTO CLEMENTE',
  'TED WILLIAMS',
  'WILLIE MAYS',
  'MUHAMMAD ALI',
  'JOE LOUIS',
  'JESSE OWENS',
  'BILLIE JEAN KING',
  'ARNOLD PALMER',
  'JACK NICKLAUS',
  'ALBERT EINSTEIN',
  'MARIE CURIE',
  'THOMAS EDISON',
  'ALEXANDER GRAHAM BELL',
  'AMELIA EARHART',
  'CHARLES LINDBERGH',
  'NEIL ARMSTRONG',
  'JOHN GLENN',
  'GEORGE MARSHALL',
  'DWIGHT EISENHOWER',
  'HARRY TRUMAN',
  'JOHN KENNEDY',
  'PABLO PICASSO',
  'NORMAN ROCKWELL',
  'GEORGIA OKEEFFE',
  'GEORGE GERSHWIN',
  'IRVING BERLIN',
  'COLE PORTER',
  'RODGERS AND HAMMERSTEIN',
  'LEONARD BERNSTEIN',
  'BENNY GOODMAN',
  'DUKE ELLINGTON',
  'COUNT BASIE',
] as const;
